module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-two"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 2")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" have known mad love. And once you have known that sort of thing, you don’t forget. So you don’t lightly enter into it (or what you sense could be ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("it")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(")")]), _c('em', {
    staticClass: "italic"
  }), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("because you know the absolute high that resides there is matched by a crushing low if it ends.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" If you’re fortunate enough that the rest of your life is fairly good, you might think maybe you don’t need that high again. You certainly know you don’t need the crush.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I thought about this as I took a cab down LaSalle Street toward the Chicago River and the boat owned by the Cortaderos. I thought about how I had started to tell my boyfriend, Theo, that I loved him when I knew he couldn’t hear me—when he was asleep, when he was in the shower with the water pounding, when he worked on his laptop and the music from his earphones (some combination hip-hop, head-banging-type stuff) was so loud and screeching, it leaked into the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Love you…” I’d say, my voice low, testing the feel of the words, experiencing a slight thrill and at the same time relief that Theo had no idea I was uttering them. Really, was I ready to go there?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It’s such a cliché when people say they’re “not ready” after getting out of a big relationship, but hell if I didn’t understand that concept now. Sam, my former fiancé, and I had broken up a little over a year ago. Then we’d considered and rejected putting our relationship back together at the end of the summer. (That’s making it sound easy. It wasn’t. But life’s struggles are always more simple in the rearview mirror.)")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" What I’ve learned is that plans only exist in the quiet space of our minds, because the fact is, the universe doesn’t respect them. Or at least the gods in my universe don’t. So I had taken great pains to weed the term ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fiancé")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" from my vernacular, just like I was cleaning it of that ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("plan")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" thing. But also, if I were honest, I was unsure if Theo would return the sentiment.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A few months ago, we decided to call each other ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("boyfriend")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" and ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("girlfriend.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I had blurted it out unintentionally once during a fairly random discussion. Panic had flooded my brain at what Theo might think, but he just smiled that sexy smile of his and called me his girlfriend, over and over again. Never before had that word made every inch of my body tingle.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Now we were using the terms loosely—")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("boyfriend, girlfriend.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But I kept asking myself, what would the three words—those three little, but oh-so-big, words—do to him?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" My cell phone bleated from my purse, as skyscrapers on LaSalle streaked across the cab window in a smear of white and gray.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I snatched the cell phone out of my bag, keen to get away from my musings. “Hello?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “McNeil. I need you for a thing.” Ah, Mayburn. I could always count on him to dispense with the pleasantries.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What kind of thing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" John Mayburn was the private detective I occasionally moonlighted for. It was sometimes fun, though often I found myself in big, big trouble and had to do a fast scramble to escape. But Mayburn had helped me way too much to not at least listen. Plus, my father worked for him now.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Super easy,” he said. “I need you to dress kinda…well, slutty and then open a checking account at a bank in the Loop tomorrow morning. Simple.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I stopped myself from rolling my eyes. Nothing was ever simple with Mayburn. A ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("simple")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" undercover retail job at a lingerie store had almost gotten me killed once. “What aren’t you telling me, Mayburn?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Lots of stuff. But seriously, that’s all we need you to do. Christopher and I have the rest covered.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Christopher. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My dad")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" and Mayburn had the rest covered. My world was so weird.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “All right,” I said. “Text me the info.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A year ago, I almost married Sam. Shortly after, I’d been accused of a friend’s death. Then the father I thought was gone had returned. It had been a hell of a year.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But really, my life was returning to normal now. I was a full-time lawyer again. I had a wonderfully hot boyfriend. And the first holiday of the season, Thanksgiving, was just two and a half weeks away. What harm could a little P.I. work do?")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 81
// module chunks = 0